export const ThemeMenuButtonMap = [
    {
        ButtonColor: "#9400D3", 
        ButtonText: "Violet Theme",
        ThemeHTML: "violet",
    }, 
    {
        ButtonColor: "#4B0082", 
        ButtonText: "Indigo Theme",
        ThemeHTML: "indigo",
    }, 
    {
        ButtonColor: "rgb(5, 5, 49)", 
        ButtonText: "Blue Theme",
        ThemeHTML: "blue",
    }, 
    {
        ButtonColor: "darkgreen", 
        ButtonText: "Green Theme",
        ThemeHTML: "green",
    }, 
    {
        ButtonColor: "#FF7F00", 
        ButtonText: "Orange Theme",
        ThemeHTML: "orange",
    }, 
    {
        ButtonColor: "#8b0000", 
        ButtonText: "Red Theme",
        ThemeHTML: "red",
    }, 
    {
        ButtonColor: "silver", 
        ButtonText: "Rainbow Theme",
        ThemeHTML: "rainbow",
    }, 
    {
        ButtonColor: "Black", 
        ButtonText: "Default Theme",
        ThemeHTML: "light",
    }, 

    {
        ButtonColor: "goldenrod", 
        ButtonText: "Custom Theme",
        ThemeHTML: "custom",
    }, 
 
]